import { SelectItem } from 'primeng/components/common/api';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TouchPointModel } from '../../../../models/touch-point.model';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';

@Component({
  selector: 'kv-promo-touch-point-detail',
  templateUrl: './touchPointDetail.component.html',
  styleUrls: ['./touchPointDetail.component.css']
})
export class TouchPointDetailComponent implements OnInit {

  @Input() touchPoint: TouchPointModel;
  @Input() titlePage = '';
  @Input() ochannel_type_pid;
  @Input() actions;
  @Input() touchPointPrivateActions;
  @Output() hide = new EventEmitter();
  @Output() saveTouchPoint = new EventEmitter();
  @Input() flgCouponScopes: SelectItem[];
  @Input() flgCouponActions: SelectItem[];
  @Input() deployableOptions: SelectItem[];

  privacyList: FormArray;
  formData: FormGroup;
  flgDeployable: boolean;
  flgOffline: boolean;
  certifier: boolean;
  flgNoDefault: boolean;
  showLayoutDialog = false;
  missingLayout: boolean;
  layoutData: any;
  renderSchemaViewer = false;
  activeFields: any[] = [];
  inactiveFields: any[] = [];
  defaultLayoutData: any;

  private readonly fieldLabelMap: { [key: string]: string } = {
    template: 'campaign.touchpoint_field_template',
    short_body: 'campaign.touchpoint_field_short_body',
    body: 'campaign.touchpoint_field_body',
    short_body_push: 'campaign.touchpoint_field_short_body_push',
    pos_img_url: 'campaign.touchpoint_field_pos_img_url',
    code: 'campaign.touchpoint_field_code',
    pos_img_b64: 'campaign.touchpoint_field_pos_img_b64',
    app_img_url: 'campaign.touchpoint_field_app_img_url',
    description: 'campaign.touchpoint_field_description',
    layout_template_pid: 'campaign.touchpoint_field_layout_template_pid',
    app_img_b64: 'campaign.touchpoint_field_app_img_b64',
    coupon_type: 'campaign.touchpoint_field_coupon_type',
  };

  constructor(private fb: FormBuilder, private campaignService: Campaign2Service) {
  }

  ngOnInit(): void {
    this.createForm();
    this.campaignService.getTouchpointLayoutDefault().subscribe((fallbackRes: any) => {
      this.defaultLayoutData = Array.isArray(fallbackRes) && fallbackRes.length > 0 ? fallbackRes[0] : fallbackRes;
    });
  }

  locationBack() {
    this.hide.emit();
  }

  save() {
    const data = {
      code: this.formData.controls['code'].value,
      description: this.formData.controls['description'].value,
      ochannel_type_pid: this.formData.controls['typePid'].value,
      flg_coupon_scope: this.formData.controls['flg_coupon_scope'].value,
      flg_coupon_action: this.formData.controls['flg_coupon_action'].value,
      flg_deployable: this.formData.controls['flg_deployable'].value,
      flg_offline: this.flgOffline ? '1' : '0',
      preview_url: this.formData.controls['preview_url'].value,
      code_preview: this.formData.controls['code_preview'].value,
      certifier: this.certifier ? '1' : '0',
      flg_no_default: this.flgNoDefault ? '1' : '0',
      max_reservable_coupons: this.formData.controls['max_reservable_coupons'].value,
      max_usable_coupons: this.formData.controls['max_usable_coupons'].value,
      max_restorable_coupons: this.formData.controls['max_restorable_coupons'].value,
    }
    if (this.touchPoint.privacyList) {
      Object.assign(data, { privacyList: this.formData.controls['privacyList'].value });
    }
    if (this.touchPoint.id) {
      Object.assign(data, { id: this.touchPoint.id })
    }
    if (this.layoutData) {
      Object.assign(data, { layout_config: this.layoutData });
    }
    this.saveTouchPoint.emit(data);
  }

  createForm() {
    this.certifier = this.touchPoint.certifier === '1' ? true : false;
    this.flgOffline = this.touchPoint.flg_offline === '1' ? true : false;
    this.flgNoDefault = this.touchPoint.flg_no_default === '1' ? true : false;
    this.formData = this.fb.group({
      'code': [this.touchPoint.code, Validators.required],
      'description': this.touchPoint.description,
      'typePid': this.touchPoint.ochannel_type_pid,
      'privacyList': this.fb.array([]),
      'flg_coupon_scope': this.touchPoint.flg_coupon_scope || null,
      'flg_coupon_action': this.touchPoint.flg_coupon_action || null,
      'flg_deployable': this.touchPoint.flg_deployable || null,
      'preview_url': this.touchPoint.preview_url,
      'code_preview': this.touchPoint.code_preview,
      'max_reservable_coupons': [this.touchPoint.max_reservable_coupons || 0, [Validators.min(0), Validators.pattern(/^\d+$/)]],
      'max_usable_coupons': [this.touchPoint.max_usable_coupons || 0, [Validators.min(0), Validators.pattern(/^\d+$/)]],
      'max_restorable_coupons': [this.touchPoint.max_restorable_coupons || 0, [Validators.min(0), Validators.pattern(/^\d+$/)]],

    });
    this.populatePrivacyListArray();
  }

  private populatePrivacyListArray() {
    this.privacyList = this.formData.get('privacyList') as FormArray;
    for (let privacy of this.touchPoint.privacyList) {
      this.privacyList.push(this.fb.group({
        'row_number': privacy.row_number,
        'flg_privacy_terminal': privacy.flg_privacy_terminal,
        'flg_privacy_mktg_profiling': privacy.flg_privacy_mktg_profiling,
        'flg_privacy_generic_comm': privacy.flg_privacy_generic_comm,
        'flg_privacy_mktg_research': privacy.flg_privacy_mktg_research,
        'flg_privacy_auth': privacy.flg_privacy_auth,
        'flg_privacy_mktg_activitiy': privacy.flg_privacy_mktg_activitiy,
        'flg_privacy_purchase_com': privacy.flg_privacy_purchase_com,
        'flg_privacy_optin': privacy.flg_privacy_optin,
        'flg_newsletter': privacy.flg_newsletter,
        'action_1_pid': privacy.action_1_pid,
        'action_2_pid': privacy.action_2_pid,
        'action_3_pid': privacy.action_3_pid,
        'action_4_pid': privacy.action_4_pid,
        'action_5_pid': privacy.action_5_pid
      }));
    }
  }

  addPrivacy() {
    this.privacyList = this.formData.get('privacyList') as FormArray;
    this.privacyList.push(this.fb.group({
      'row_number': 0,
      'flg_privacy_terminal': false,
      'flg_privacy_mktg_profiling': false,
      'flg_privacy_generic_comm': false,
      'flg_privacy_mktg_research': false,
      'flg_privacy_auth': false,
      'flg_privacy_mktg_activitiy': false,
      'flg_privacy_purchase_com': false,
      'flg_privacy_optin': false,
      'flg_newsletter': false,
      'action_1_pid': null,
      'action_2_pid': null,
      'action_3_pid': null,
      'action_4_pid': null,
      'action_5_pid': null
    }));
  }

  deletePrivacyList(index) {
    this.privacyList = this.formData.get('privacyList') as FormArray;
    this.privacyList.removeAt(index);
  }

  checkScopeUndefined(scope: string) {
    if (scope === "N") {
      this.formData.controls['flg_coupon_action'].setValue("N");
    }
  }

  checkActionUndefined(action: string) {
    if (action === "N") {
      this.formData.controls['flg_coupon_scope'].setValue("N");
    }
  }

  updateActiveFields() {
    this.activeFields = [];
    this.inactiveFields = [];

    if (this.defaultLayoutData && this.defaultLayoutData.form_schema && this.defaultLayoutData.form_schema.properties) {
       const allDefaultKeys = Object.keys(this.defaultLayoutData.form_schema.properties);
       for (const key of allDefaultKeys) {
          if (key === 'form') {
             const defaultForms = this.defaultLayoutData.form_schema.properties['form'].default || [];
             const activeForms = (this.layoutData && this.layoutData.form_schema && this.layoutData.form_schema.properties && this.layoutData.form_schema.properties['form'] && this.layoutData.form_schema.properties['form'].default) 
                                  ? this.layoutData.form_schema.properties['form'].default 
                                  : [];
             
             if (activeForms.length === 0 && defaultForms.length > 0 && !this.layoutData.form_schema.properties['form']) {
                // If the entire form object is missing, we consider them all inactive
                for (const defItem of defaultForms) {
                   this.inactiveFields.push({ id: `form:${defItem.det_id}`, label: `form -> ${defItem.det_id}`, isDet: true, detId: defItem.det_id });
                }
             } else {
                for (const defItem of defaultForms) {
                   const detId = defItem.det_id;
                   const isActive = activeForms.findIndex(x => x.det_id === detId) > -1;
                   if (isActive) {
                      this.activeFields.push({ id: `form:${detId}`, label: detId, isDet: true, detId: detId });
                   } else {
                      this.inactiveFields.push({ id: `form:${detId}`, label: detId, isDet: true, detId: detId });
                   }
                }
             }
          } else {
             const propDef = this.defaultLayoutData.form_schema.properties[key];
             if (propDef && propDef.hidden === true) continue;
             const label = this.fieldLabelMap[key] || (propDef && propDef.title) || key;
             const isActive = (this.layoutData && this.layoutData.form_schema && this.layoutData.form_schema.properties && this.layoutData.form_schema.properties[key]);
             if (isActive) {
                this.activeFields.push({ id: key, label, isDet: false, detId: null });
             } else {
                this.inactiveFields.push({ id: key, label, isDet: false, detId: null });
             }
          }
       }
    }
  }

  openLayoutDialog(touchpoint: any) {
    if (this.layoutData) {
      this.updateActiveFields();
      this.showLayoutDialog = true;
      this.renderSchemaViewer = true;
      return;
    }

    if (touchpoint && touchpoint.id) {
      this.campaignService.getTouchpointLayoutById(touchpoint.id).subscribe((res: any) => {
        const isEmpty = !res || (Array.isArray(res) && res.length === 0) || (typeof res === 'object' && !Array.isArray(res) && Object.keys(res).length === 0);

        if (isEmpty) {
          if (this.defaultLayoutData) {
            this.layoutData = JSON.parse(JSON.stringify(this.defaultLayoutData));
            this.updateActiveFields();
            this.showLayoutDialog = true;
            this.renderSchemaViewer = true;
          }
        } else {
          this.layoutData = Array.isArray(res) && res.length > 0 ? res[0] : res;
          this.updateActiveFields();
          this.showLayoutDialog = true;
          this.renderSchemaViewer = true;
        }
      });
    } else {
      if (this.defaultLayoutData) {
        this.layoutData = JSON.parse(JSON.stringify(this.defaultLayoutData));
        this.updateActiveFields();
        this.showLayoutDialog = true;
        this.renderSchemaViewer = true;
      }
    }
  }

  closeLayoutDialog() {
    this.showLayoutDialog = false;
    this.missingLayout = false;
    this.renderSchemaViewer = false;
  }

  // removed getKeys method

  removeFieldFromSchema(field: any) {
    if (!this.layoutData || !this.layoutData.form_schema || !this.layoutData.form_schema.properties) return;

    if (field.isDet) {
       if (this.layoutData.form_schema.properties['form'] && this.layoutData.form_schema.properties['form'].default) {
          const arr = this.layoutData.form_schema.properties['form'].default;
          const idx = arr.findIndex(x => x.det_id === field.detId);
          if (idx > -1) arr.splice(idx, 1);
       }
       if (this.layoutData.form_values && this.layoutData.form_values['form']) {
          const arr = this.layoutData.form_values['form'];
          const idx = arr.findIndex(x => x.det_id === field.detId);
          if (idx > -1) arr.splice(idx, 1);
       }
    } else {
       const key = field.id;
       delete this.layoutData.form_schema.properties[key];
       
       if (this.layoutData.json_schema && this.layoutData.json_schema.properties) {
          delete this.layoutData.json_schema.properties[key];
       }
       if (this.layoutData.form_values) {
          delete this.layoutData.form_values[key];
       }
       
       if (this.layoutData.form_schema.order) {
          const idx = this.layoutData.form_schema.order.indexOf(key);
          if (idx > -1) this.layoutData.form_schema.order.splice(idx, 1);
       }
       if (this.layoutData.form_schema.required) {
          const idx = this.layoutData.form_schema.required.indexOf(key);
          if (idx > -1) this.layoutData.form_schema.required.splice(idx, 1);
       }
       if (this.layoutData.json_schema && this.layoutData.json_schema.required) {
          const idx = this.layoutData.json_schema.required.indexOf(key);
          if (idx > -1) this.layoutData.json_schema.required.splice(idx, 1);
       }
    }

    this.syncJsonSchema();
    this.updateActiveFields();
    this.renderSchemaViewer = false;
    setTimeout(() => {
       this.renderSchemaViewer = true;
    }, 50);
  }

  addFieldToSchema(field: any) {
    if (!this.layoutData || !this.layoutData.form_schema || !this.defaultLayoutData) return;

    if (field.isDet) {
       if (!this.layoutData.form_schema.properties['form']) {
          this.layoutData.form_schema.properties['form'] = JSON.parse(JSON.stringify(this.defaultLayoutData.form_schema.properties['form']));
          this.layoutData.form_schema.properties['form'].default = [];
       }
       const defaultArr = this.defaultLayoutData.form_schema.properties['form'].default || [];
       const targetArr = this.layoutData.form_schema.properties['form'].default;
       
       const newArr = [];
       for (const defItem of defaultArr) {
          const existing = targetArr.find(x => x.det_id === defItem.det_id);
          if (existing) {
             newArr.push(existing);
          } else if (defItem.det_id === field.detId) {
             newArr.push(JSON.parse(JSON.stringify(defItem)));
          }
       }
       this.layoutData.form_schema.properties['form'].default = newArr;

       if (this.defaultLayoutData.form_values && this.defaultLayoutData.form_values['form']) {
          if (!this.layoutData.form_values) this.layoutData.form_values = {};
          if (!this.layoutData.form_values['form']) this.layoutData.form_values['form'] = [];
          
          const defaultVals = this.defaultLayoutData.form_values['form'];
          const targetVals = this.layoutData.form_values['form'];
          const newVals = [];
          for (const defVal of defaultVals) {
             const existing = targetVals.find(x => x.det_id === defVal.det_id);
             if (existing) {
                newVals.push(existing);
             } else if (defVal.det_id === field.detId) {
                newVals.push(JSON.parse(JSON.stringify(defVal)));
             }
          }
          this.layoutData.form_values['form'] = newVals;
       }
    } else {
       const key = field.id;
       if (!this.layoutData.form_schema.properties) this.layoutData.form_schema.properties = {};
       this.layoutData.form_schema.properties[key] = JSON.parse(JSON.stringify(this.defaultLayoutData.form_schema.properties[key]));
       
       if (this.defaultLayoutData.json_schema && this.defaultLayoutData.json_schema.properties && this.defaultLayoutData.json_schema.properties[key]) {
          if (!this.layoutData.json_schema) this.layoutData.json_schema = {};
          if (!this.layoutData.json_schema.properties) this.layoutData.json_schema.properties = {};
          this.layoutData.json_schema.properties[key] = JSON.parse(JSON.stringify(this.defaultLayoutData.json_schema.properties[key]));
       }
       
       if (this.defaultLayoutData.form_values && this.defaultLayoutData.form_values[key] !== undefined) {
          if (!this.layoutData.form_values) this.layoutData.form_values = {};
          this.layoutData.form_values[key] = JSON.parse(JSON.stringify(this.defaultLayoutData.form_values[key]));
       }

       if (this.defaultLayoutData.form_schema.required && this.defaultLayoutData.form_schema.required.indexOf(key) > -1) {
          if (!this.layoutData.form_schema.required) this.layoutData.form_schema.required = [];
          if (this.layoutData.form_schema.required.indexOf(key) === -1) {
             this.layoutData.form_schema.required.push(key);
          }
       }

       if (this.defaultLayoutData.form_schema.order) {
          this.layoutData.form_schema.order = this.defaultLayoutData.form_schema.order.filter(
             (k: string) => Object.keys(this.layoutData.form_schema.properties).indexOf(k) > -1
          );
       }
       
       if (this.defaultLayoutData.json_schema && this.defaultLayoutData.json_schema.required && this.defaultLayoutData.json_schema.required.indexOf(key) > -1) {
          if (!this.layoutData.json_schema) this.layoutData.json_schema = { required: [] };
          if (!this.layoutData.json_schema.required) this.layoutData.json_schema.required = [];
          if (this.layoutData.json_schema.required.indexOf(key) === -1) {
             this.layoutData.json_schema.required.push(key);
          }
       }
    }

    this.syncJsonSchema();
    this.updateActiveFields();
    this.renderSchemaViewer = false;
    setTimeout(() => {
       this.renderSchemaViewer = true;
    }, 50);
  }

  private syncJsonSchema() {
    if (!this.layoutData || !this.layoutData.form_schema || !this.layoutData.form_schema.properties) return;

    if (this.layoutData.form_schema.order) {
      const orderedKeys: string[] = this.layoutData.form_schema.order;
      Object.keys(this.layoutData.form_schema.properties).forEach(k => {
        if (orderedKeys.indexOf(k) === -1) {
          delete this.layoutData.form_schema.properties[k];
        }
      });
    } else if (this.layoutData.form_schema.fieldsets) {
      const fieldsetKeys: string[] = [];
      this.layoutData.form_schema.fieldsets.forEach((fs: any) => {
        if (fs.fields) {
          fs.fields.forEach((f: string) => fieldsetKeys.push(f));
        }
      });
      Object.keys(this.layoutData.form_schema.properties).forEach(k => {
        if (fieldsetKeys.indexOf(k) === -1) {
          delete this.layoutData.form_schema.properties[k];
        }
      });
    }

    const activeKeys = Object.keys(this.layoutData.form_schema.properties);

    // Allinea json_schema con le properties attive
    if (this.layoutData.json_schema && this.layoutData.json_schema.properties) {
      Object.keys(this.layoutData.json_schema.properties).forEach(k => {
        if (activeKeys.indexOf(k) === -1) {
          delete this.layoutData.json_schema.properties[k];
        }
      });
      if (this.layoutData.json_schema.required) {
        this.layoutData.json_schema.required = this.layoutData.json_schema.required.filter((k: string) => activeKeys.indexOf(k) > -1);
      }
    }

    // Pulisce visibleIf nelle properties (riferimenti a campi non più attivi)
    this.cleanVisibleIf(this.layoutData.form_schema.properties, activeKeys);
    if (this.layoutData.json_schema && this.layoutData.json_schema.properties) {
      this.cleanVisibleIf(this.layoutData.json_schema.properties, activeKeys);
    }
  }

  private cleanVisibleIf(properties: any, activeKeys: string[]) {
    if (!properties) return;
    Object.keys(properties).forEach(k => {
      const prop = properties[k];
      if (prop && prop.visibleIf) {
        Object.keys(prop.visibleIf).forEach(refKey => {
          if (activeKeys.indexOf(refKey) === -1) {
            delete prop.visibleIf[refKey];
          }
        });
        if (Object.keys(prop.visibleIf).length === 0) {
          delete prop.visibleIf;
        }
      }
    });
  }

  saveLayoutStructure() {
    this.closeLayoutDialog();
  }
}


// WEBPACK FOOTER //
// ./src/app/views/promotion/touch-point/components/touchPointDetail.component.ts